var React = require('react');

function Telephone (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"},[React.createElement("path",{"stroke":"#3b4b6f","d":"M7.904 1.78a2.767 2.767 0 0 0-3.991.15C-1.296 7.89.49 19.086 9.78 28.56c10.65 10.861 21.128 11.541 26.836 5.968a2.549 2.549 0 0 0 .051-3.56l-5.058-5.4a2.274 2.274 0 0 0-3.2-.119l-3.955 3.636A42.29 42.29 0 0 1 9.427 13.514l3.674-3.429a2.274 2.274 0 0 0 .022-3.3Z","key":0}),React.createElement("path",{"stroke":"#4a4aff","d":"M36.244 19.581A17.747 17.747 0 0 0 18.827 1.838m.169 5.98a11.773 11.773 0 0 1 11.275 11.763","key":1})]));
}

Telephone.defaultProps = {"viewBox":"0 0 38.572 38.983"};

module.exports = Telephone;

Telephone.default = Telephone;
